import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import uuidV4 from 'uuid/v4';
import {window} from 'ssr-window';
import serialize from 'form-serialize';
import {notify} from 'notification/notification-actions';

export default EnhancedComponent => {
    class WithBranchTextApp extends Component {
        static propTypes = {
            appStoreLinkChannel: PropTypes.oneOf(['prepurchase', 'postpurchase']),
            phoneNumber: PropTypes.string,
            phoneNumberFriendly: PropTypes.string,
            weekdayHours: PropTypes.string,
            weekendHours: PropTypes.string,
            sendNotification: PropTypes.func.isRequired
        };
        static defaultProps = {
            appStoreLinkChannel: 'prepurchase'
        };
        state = {
            isSubmitting: false
        };

        _onAppSent = (error, result) => {
            const {
                sendNotification
            } = this.props;

            this.setState({
                isSubmitting: false
            });

            if (error) {
                sendNotification({
                    id: uuidV4(),
                    type: 'error',
                    message: 'There was an issue sending, please try again.'
                });
            } else {
                sendNotification({
                    id: uuidV4(),
                    type: 'success',
                    message: 'Success! You should receive a text message shortly.'
                });
            }
        }

        _onSubmit = evt => {
            const {
                phone
            } = serialize(evt.target, {hash: true});

            if (!phone) {
                return;
            }

            this.setState({
                isSubmitting: true
            });

            window.branch.sendSMS(phone, {
                tags: [],
                channel: 'Web',
                feature: 'TextMeOurApp'
            }, {}, this._onAppSent);
        }

        render() {
            const {
                appStoreLinkChannel,
                phoneNumber,
                phoneNumberFriendly,
                weekdayHours,
                weekendHours
            } = this.props;
            const {
                isSubmitting
            } = this.state;

            return (
                <EnhancedComponent
                    appStoreLinkChannel={appStoreLinkChannel}
                    isSubmitting={isSubmitting}
                    onSubmit={this._onSubmit}
                    phoneNumber={phoneNumber}
                    phoneNumberFriendly={phoneNumberFriendly}
                    weekdayHours={weekdayHours}
                    weekendHours={weekendHours}
                />
            );
        }
    }

    const mapDispatchToProps = {
        sendNotification: notify
    };

    return connect(null, mapDispatchToProps)(WithBranchTextApp);
};
